import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import Swal from "sweetalert2";
export default function TextFieldEmail(props) {
  const [error, setError] = useState(false);

  const validateEmail = (email) => {
    // Expressão regular simples para validação de e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (event) => {
    const newValue = event.target.value;

    // Atualiza erro caso o e-mail não seja válido
    setError(newValue.length > 0 && !validateEmail(newValue));

    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <TextField
      {...props}
      type="email"
      error={error}
      setStatusError ={()=>{
        if(props.setStatusError){
            props.setStatusError(error);
        }
      }}
      helperText={error ? "E-mail inválido" : ""}
      onChange={handleChange}
      onBlur={()=>{
              if(error){
                  Swal.fire({
                      title : 'Corporate Web', 
                      text : 'O Email informado é inválido! Verifique!', 
                      icon : 'error', 
                      showConfirmButton : false, 
                      showCancelButton : false,
                      timer : 1500
                  })
              }
            }}
    />
  );
}
